import React, { createContext, useContext } from 'react';
import { type LocaleDefinition } from './locale-translations/types';

const LocaleContext = createContext<LocaleDefinition | null>(null);

/**
 * Returns the current locale provided by the nearest `LocaleProvider`.
 * Throws if used outside of a `LocaleProvider`.
 */
export function useLocale(): LocaleDefinition {
  const locale = useContext(LocaleContext);
  if (!locale) {
    throw new Error('useLocale must be used within a LocaleProvider');
  }
  return locale;
}

export function LocaleProvider({
  locale,
  children,
}: {
  locale: LocaleDefinition;
  children: React.ReactNode;
}) {
  return <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>;
}
